const getItem = (name, defaultValue) => {
  try {
    const value = JSON.parse(localStorage.getItem(name))

    return value !== null ? value : defaultValue
  }
  catch (err) {
    console.log(name)
    console.error(err)

    return defaultValue
  }
}

const setItem = (name, value) => {
  try {
    localStorage.setItem(name, JSON.stringify(value))
  }
  catch (err) {
    console.log(name, value)
    console.error(err)
  }
}

const removeItem = (name) => {
  try {
    localStorage.removeItem(name)
  }
  catch (err) {
    console.log(name)
    console.error(err)
  }
}

const getSessionItem = (name, defaultValue) => {
  try {
    const value = JSON.parse(sessionStorage.getItem(name))

    return value !== null ? value : defaultValue
  }
  catch (err) {
    console.log(name)
    console.error(err)

    return defaultValue
  }
}

const setSessionItem = (name, value) => {
  try {
    sessionStorage.setItem(name, JSON.stringify(value))
  }
  catch (err) {
    console.log(name, value)
    console.error(err)
  }
}

const removeSessionItem = (name) => {
  try {
    sessionStorage.removeItem(name)
  }
  catch (err) {
    console.log(name)
    console.error(err)
  }
}


export default {
  getItem,
  setItem,
  removeItem,
  getSessionItem,
  setSessionItem,
  removeSessionItem,
}
